// @flow
import * as ActionTypes from "../actionTypes";
import { createAction } from "redux-actions";
import {doSignIn, doSignOut} from "./auth";

type Action = {
  +type: string,
  +payload?: any,
  +error?: boolean,
  +meta?: any
};

export const userLoginRequested:Action = createAction(ActionTypes.USER_LOGIN_REQUESTED)
export const userLoginReceived:Action = createAction(ActionTypes.USER_LOGIN_RECEIVED)
export const userLoginFailed:Action = createAction(ActionTypes.USER_LOGIN_FAILED)

export const userLogoutRequested:Action = createAction(ActionTypes.USER_LOGOUT_REQUESTED)
export const userLogoutReceived:Action = createAction(ActionTypes.USER_LOGOUT_RECEIVED)
export const userLogoutFailed:Action = createAction(ActionTypes.USER_LOGOUT_FAILED)


// firebase methods
export const authenticateAndLogInUser = (email, password) => async dispatch => {
  dispatch(userLoginRequested())
  try {
    const authUser = await doSignIn(email, password)
    const tokenPayload = await authUser.getIdTokenResult()
    const access_token = tokenPayload.token
    const role = tokenPayload.claims.role
    const locationId = tokenPayload.claims.locationId
    const userId = authUser.uid;
    dispatch(userLoginReceived({ access_token, role, userId, locationId }))
    return true
  } catch (err) {
    console.log(err)
    dispatch(userLoginFailed('Invalid username/password.'))
    return false
  }
}

export const unAuthenticateAndLogoutUser = () => async dispatch => {
  dispatch(userLogoutRequested())
  try {
    await doSignOut()
    // todo, reset redux
    dispatch(userLogoutReceived())
  } catch(err) {
    console.log(err)
    dispatch(userLogoutFailed('Could not log user out.'))
  }
}



// WEBPACK FOOTER //
// ./src/security/securityActions.js